(function($){
  jQuery(document).ready(function() {
    
    var box1 = $(".boxnum-2 .YPHeroU2-top_box1");
    var box2 = $(".boxnum-2 .YPHeroU2-bottom_box1");

    var box3_1 = $(".boxnum-3 .YPHeroU2-top_box1");
    var box3_2 = $(".boxnum-3 .YPHeroU2-bottom_box1");
    var box3_3 = $(".boxnum-3 .YPHeroU2-top_box2");

    var box4_1 = $(".boxnum-4 .YPHeroU2-top_box1");
    var box4_2 = $(".boxnum-4 .YPHeroU2-bottom_box1");
    var box4_3 = $(".boxnum-4 .YPHeroU2-top_box2");
    var box4_4 = $(".boxnum-4 .YPHeroU2-bottom_box2");
  
    function loop2() {
      $.when(
        box1.animate({opacity: '1'}, 1000).promise(),
      ).done(function() {
        box1.delay(4000).animate({opacity: '0'}, 1000).promise()
        .done(function() {
          box2.animate({opacity: '1'}, 1000).promise()
          .done(function() {
            box2.delay(4000).animate({opacity: '0'}, 1000, loop2).promise()
          })
        })
      });
    }
    loop2();

    function loop3() {
      $.when(
        box3_1.animate({opacity: '1'}, 1000).promise(),
      ).done(function() {
        box3_1.delay(4000).animate({opacity: '0'}, 1000).promise()
        .done(function() {
          box3_2.animate({opacity: '1'}, 1000).promise()
          .done(function() {
            box3_2.delay(4000).animate({opacity: '0'}, 1000).promise()
            .done(function() {
              box3_3.animate({opacity: '1'}, 1000).promise()
              .done(function() {
                box3_3.delay(4000).animate({opacity: '0'}, 1000, loop3).promise()
              })
            })
          })
        })
      });
    }
    loop3();

    function loop4() {
      $.when(
        box4_1.animate({opacity: '1'}, 1000).promise(),
      ).done(function() {
        box4_1.delay(4000).animate({opacity: '0'}, 1000).promise()
        .done(function() {
          box4_2.animate({opacity: '1'}, 1000).promise()
          .done(function() {
            box4_2.delay(4000).animate({opacity: '0'}, 1000).promise()
            .done(function() {
              box4_3.animate({opacity: '1'}, 1000).promise()
              .done(function() {
                box4_3.delay(4000).animate({opacity: '0'}, 1000).promise()
                .done(function() {
                  box4_4.animate({opacity: '1'}, 1000).promise()
                  .done(function() {
                    box4_4.delay(4000).animate({opacity: '0'}, 1000, loop4).promise()
                  })
                })
              })
            })
          })
        })
      });
    }
    loop4();

  });
})(jQuery);